export default function PreReserveCTA() {
  return (
    <section className="pre-reserve-section">
      <div className="pre-reserve-container">
        
        {/* LEFT CONTENT */}
        <div className="pre-reserve-text">
          <h1>PREPARE FOR DOMINANCE</h1>
          <p>Pre-reserve now. Begin your era of dominance.</p>
        </div>

        {/* RIGHT BUTTON */}
        <a
          href="https://www.mgmotor.co.in/vehicles/mg-majestor-biggest-suv-india/pre-reserve"
          target="_blank"
          rel="noopener noreferrer"
          className="pre-reserve-btn"
        >
          PRE-RESERVE
          <img
    src={`https://www.mgmotor.co.in/etc.clientlibs/mgmotor-redesign/clientlibs/clientlib-site/resources/icons/arrow-diagonal-white.svg`}
    alt="arrow"
    className="btn-icon"
  />
        </a>

      </div>

      <style>{`
        .pre-reserve-section {
          width: 100%;
          padding: 80px 20px;
        //   background: #f4f4f4;
          display: flex;
          justify-content: center;
        }

        .pre-reserve-container {
          width: 100%;
          max-width: 1400px;
          background: linear-gradient(90deg, #1c1c1c, #2a2a2a);
          border-radius: 10px;
          padding: 60px 80px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: white;
        }

        .pre-reserve-text h1 {
          font-size: 42px;
          font-weight: 800;
          letter-spacing: 2px;
          margin-bottom: 15px;
        }

        .pre-reserve-text p {
          font-size: 18px;
          opacity: 0.8;
        }
        .btn-icon {
  width: 18px;
  height: 18px;
}

        .pre-reserve-btn {
          background: #e10600;
          color: white;
          padding: 16px 40px;
          border-radius: 8px;
          text-decoration: none;
          font-weight: 600;
          display: inline-flex;
          align-items: center;
          gap: 12px;
          transition: all 0.3s ease;
        }

        .pre-reserve-btn:hover {
          background: #b80000;
          transform: translateY(-2px);
        }

        .arrow {
          font-size: 18px;
        }

        /* Tablet */
        @media (max-width: 1024px) {
          .pre-reserve-container {
            flex-direction: column;
            gap: 30px;
            text-align: center;
          }

          .pre-reserve-text h1 {
            font-size: 32px;
          }
        }

        /* Mobile */
        @media (max-width: 768px) {
          .pre-reserve-container {
            padding: 40px 30px;
          }

          .pre-reserve-text h1 {
            font-size: 26px;
          }

          .pre-reserve-text p {
            font-size: 15px;
          }
        }

      `}</style>
    </section>
  );
}
